import Notifications from './Notifications';
import connectContainer from './NotificationsContainer';

export default connectContainer(Notifications);
